import React from 'react';

const Image = ({ src,className }) => <img alt={""} className={className} src={`../../images/${src}`}/>
export default Image;